module.exports = __webpack_public_path__ + "img/03.fb9ffd52.png";